import React, { useState } from 'react';
import { auth, db } from '../firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import Logo from '../assets/loyaltap_logo.png';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Login.css';

const Login = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      const userDoc = await getDoc(doc(db, 'admin_users', userId));

      if (userDoc.exists()) {
        const data = userDoc.data();
        localStorage.setItem('userRole', data.role);
        localStorage.setItem('coffee_shop_id', data.coffee_shop_id);
        localStorage.setItem('coffee_shop_name', data.coffee_shop_name);
        navigate('/dashboard');
      } else {
        throw new Error('User role not found.');
      }
    } catch (err) {
      setError(err.message);
      console.error(err);
    }
  };

  return (
    <div className="login-page">
      <div className="language-switcher">
        <button onClick={() => i18n.changeLanguage('en')}>🇬🇧</button>
        <button onClick={() => i18n.changeLanguage('ro')}>🇷🇴</button>
        <button onClick={() => i18n.changeLanguage('sv')}>🇸🇪</button>
      </div>

      <div className="login-box">
        <div className="logo-container1">
          <img src={Logo} alt="LoyalTap Logo" className="logo-image" />
        </div>

        <h2>🔐 {t('login.title')}</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder={t('login.email')}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder={t('login.password')}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="login-button">
            {t('login.button')}
          </button>

          <Link to="/about-loyaltap" className="webshop-button">
            {t('about.title_loyaltap')}
          </Link>
          <button onClick={() => navigate('/top-locations')}>
  {t('public_listing.top_rated_locations')}
</button>
<button
  onClick={() => window.location.href = "/public-clinic-landing"}
  className="top-rated-clinics-btn"
>
   {t('public_listing.top_rated_clinics')}
</button>

          <a
            href="https://www.Flexpayz.se"
            target="_blank"
            rel="noopener noreferrer"
            className="webshop-button"
          >
            {t('login.visitWebshop')}
          </a>
        </form>

        {error && (
          <p className="error-message">
            {t('login.error', { message: error })}
          </p>
        )}

        <p className="tagline">
          {t('login.tagline', { tech: 'FlexPayz' })}
        </p>
      </div>
    </div>
  );
};

export default Login;